import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import Panel from './Panel.js';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/**
 * Composant Domains
 * Utilise withBreakpointManager pour basculer entre les versions mobile et desktop
 */
export default class Terroirs extends Base {
  static config = {
    name: 'Terroirs',
    components: {
      Panel,
    },
    refs: ['container', 'items[]', 'pins[]', 'cards[]', 'cardsLink[]'],
  };

  breakpoints = ['xxs', 'xs', 's'];
  zIndex = 0;
  currentIndex = 0;

  /**
   *
   */
  mounted() {
    this.currentPin = document.querySelector(`#${this.$refs.items[0].dataset.slug}`);
    const endScroll = this.$refs.items.length * 40;

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.container,
        start: 'top top',
        end: `+=${endScroll}%`,
        stagger: 0.1,
        pin: true,
        scrub: 0.1,
      },
    });

    this.tl.to(this.$el, { opacity: 1, duration: 0.2 });

    this.$refs.items.forEach((item, index) => {
      if (index !== 0) {
        const nextYPosition = index * -100;
        this.tl.to(this.$refs.items, {
          yPercent: nextYPosition,
          duration: 1,
          ease: 'none',
          onReverseComplete: () => {
            this.switchItemStates(index - 1);
          },
          onComplete: () => {
            gsap.to(this.$refs.cards[index].querySelectorAll('.card-item'), {
              y: 0,
              opacity: 1,
              ease: 'power4.out',
              stagger: 0.02,
            });
            this.switchItemStates(index);
          },
        });
      }
      this.tl.addLabel(this.$refs.items[index].dataset.slug);
    });
    this.tl.to(this.$el, { opacity: 1, duration: 0.5 });
  }

  /**
   * Scroll to section associate to pin
   * @param {object} props object.
   * @param {object} props.target current item clicked.
   */
  onPinsClick({ target }) {
    gsap.to(window, { scrollTo: this.tl.scrollTrigger.labelToScroll(target.id) });
  }

  /**
   * When clicking on cards, fetch content from page
   * @param {object} props
   * @param {Event} props.target current element
   */
  onCardsLinkClick({ target }) {
    const id = target.dataset.id;
    target.querySelector('.loader').classList.remove('opacity-0');
    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=render_template&template=panel-domain&security=custom_nonce&data=${encodeURIComponent(id)}`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$children.Panel[0].addData(response.data);
        target.querySelector('.loader').classList.add('opacity-0');
      });
  }

  /**
   * Switch item and image states
   * @param {number} index current index
   * @returns {void}
   */
  switchItemStates(index) {
    if (index < 0) {
      return;
    }

    this.$refs.items.forEach((item, i) => {
      if (i !== index) {
        item.classList.add('m:opacity-30');
      }
    });

    if (this.currentPin) {
      this.currentPin.classList.remove('active');
    }

    if (this.$refs.items[index]) {
      this.$refs.items[index].classList.remove('m:opacity-30');
      this.currentPin = document.querySelector(`#${this.$refs.items[index].dataset.slug}`);

      if (this.currentPin) {
        this.currentPin.classList.add('active');
      }
      this.currentIndex = index;
    }
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
